// This function is used to get the query params from the url. This will be useful to get affiliate query params from the url.

export default function getQueryParams(url: string): Record<string, any> {
  const urlWithoutHash = url.split('#')[0];
  const queryString = urlWithoutHash.includes('?')
    ? urlWithoutHash.split('?')[1]
    : '';
  const urlParams = new URLSearchParams(queryString);
  const params: Record<string, any> = {};

  urlParams.forEach((value, key) => {
    params[key] = value;
  });
  return params;
}
